import { graphql, DataValue } from '@apollo/client/react/hoc';
import React from 'react';

import Checkbox from 'components/Checkbox';
import MediaObject from 'components/MediaObject';
import MenuItem from 'components/MenuItem';
import Text from 'components/Text';
import TextWithTooltip from 'components/TextWithTooltip';

import RECIPIENT_COUNT_QUERY from 'queries/RecipientCount.gql';

import type { QueryCountRecipients } from 'queries/__generated__/QueryCountRecipients';

export type Props = {
  // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'MessageFilterType'.
  filter: MessageFilterType;
  // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'MessageFilterType'.
  nonRoleFilters: MessageFilterType[];
  imageSrc: any;
  isSelected: boolean;
  orgUuid: string | undefined | null;
  groupUuid: string | undefined | null;
  onClick: Function;
  dataTestSelector: string | undefined | null;
  data?: DataValue<QueryCountRecipients>;
  rosteredIncompatible: boolean;
  gradesIncompatible: boolean;
};

class TargetFilterMenuItem extends React.Component<Props, any> {
  render() {
    const { data, filter, isSelected, onClick, rosteredIncompatible, gradesIncompatible } =
      this.props;
    const countIsLoaded = data && !!data.countRecipients;
    const filterText = filter.value.id === 'all' ? 'Everyone' : filter.value.label;

    let tooltipMessage = '';
    if (rosteredIncompatible) {
      tooltipMessage =
        "This role can't be filtered by SIS-link. Deselect SIS link filters to select.";
    } else if (gradesIncompatible) {
      tooltipMessage = "This role can't be filtered by grades. Deselect grades filters to select.";
    }
    const disabled = rosteredIncompatible || gradesIncompatible;
    const innerText = (
      <MediaObject center gutter="xsmall">
        <Checkbox checked={isSelected && !disabled} onChange={() => null} disabled={disabled} />
        <Text
          size="xsmall"
          color="graphite"
          // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
          disabled={disabled}
          data-test-selector={`${this.props.dataTestSelector || ''}-${filterText}`}
          data-testid={`${this.props.dataTestSelector || ''}-${filterText}`}
        >
          {filterText}
          {countIsLoaded && (
            // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
            <Text size="xsmall" color="graphite" disabled={disabled}>
              {'  '}({data.countRecipients?.count})
            </Text>
          )}
        </Text>
      </MediaObject>
    );
    const itemText = disabled ? (
      <TextWithTooltip
        tooltip={tooltipMessage}
        tooltipPlacement="bottom"
        // @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: Element; tooltip: string; toolti... Remove this comment to see the full error message
        weight="normal"
        color="paper"
      >
        {innerText}
      </TextWithTooltip>
    ) : (
      innerText
    );

    return (
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      <MenuItem key={filter.value.id} onClick={onClick}>
        {itemText}
      </MenuItem>
    );
  }
}

const withCount = graphql(RECIPIENT_COUNT_QUERY, {
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'orgUuid' does not exist on type '{}'.
  skip: ({ orgUuid, groupUuid }) => !orgUuid && !groupUuid,
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'orgUuid' does not exist on type '{}'.
  options: ({ orgUuid, groupUuid, filter, nonRoleFilters }) => {
    const isOrg = !!orgUuid;
    const type = isOrg ? 'organization' : 'group';
    const uuid = isOrg ? orgUuid : groupUuid;
    // Be aware that this component is sending not only the role filter to
    // the counting query in apollo but also additional filtering information
    // (nonroleFilters, i.e. grades, sislinked) so in this case the set of
    // filters is composed as the set of nonrolefilters with the actual role
    // filter added afterwards
    if (filter.value.id !== 'all') {
      nonRoleFilters.push({ [filter.type]: [filter.value.id] });
    }
    const filters = nonRoleFilters;
    return {
      variables: { input: { type, uuid, filters } },
    };
  },
});

export { TargetFilterMenuItem };

// @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof TargetFilterMenuItem' is ... Remove this comment to see the full error message
export default withCount(TargetFilterMenuItem);
